import { address, error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ValidateAddressV2 = gql`
  query ValidateAddressV2($input: ValidateAddressV2Input!) {
    validateAddressV2(input: $input) {
      __typename
      ... on ValidAddress {
        message
        originalAddress {
          ...address
          externalId
        }
      }
      ... on SuggestedAddress {
        message
        suggestedAddress {
          ...address
          externalId
        }
        originalAddress {
          ...address
          externalId
        }
        fields {
          ...AddressFieldValidations
        }
      }
      ... on InvalidAddress {
        message
        originalAddress {
          ...address
          externalId
        }
        fields {
          ...AddressFieldValidations
        }
      }
      ... on AllowOverrideAddress {
        message
        originalAddress {
          ...address
          externalId
        }
      }
      ...error
    }
  }

  fragment AddressFieldValidations on AddressFieldValidation {
    id
    message
    addressField
  }
  ${address}
  ${error}
`;

export default ValidateAddressV2;
